<template>
    <transition name="slide">
        <div class="group-box" :class="{ 'big-screen': isBig }" v-if="visible">
            <img class="close" style="cursor: pointer;" @click="close" src="../../assets/image/magSys/del.png" alt="">
            <div class="top">
                <img style="width: 3.6rem;height: auto;" src="../../assets/image/user.png" alt="">
                <p>组建课程</p>
                <el-tooltip class="item" effect="dark" content="全屏" placement="top-start">
                    <i class="iconfont icon-quanping1" @click="openBig(true)" v-show="!isBig"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="退出全屏" placement="top-start">
                    <i class="iconfont icon-quxiaoquanping" @click="openBig(false)" v-show="isBig"></i>
                </el-tooltip>
            </div>
            <div class="talk-box">
                <img style="width: 4rem;height: auto;" src="../../assets/image/magSys/robot.png" alt="">
                <div class="ipt-box">
                    <div class="content-box">
                        <div v-for="(item, index) in questionInfos" :key="index" class="question-item">
                            <p class="user-question" v-if="item.userQuestion">{{ item.userQuestion }}</p>
                            <div class="dot-box" v-if="!item.questionAnswer">
                                <div class="dot"></div>
                                <div class="dot"></div>
                                <div class="dot"></div>
                            </div>
                            <div class="question-answer" v-else v-html="item.questionAnswer"></div>
                            <div class="opt-box" v-if="item.isEnding && item.status">
                                <p @click="copy(item)">复制</p>
                                <p @click="useString(item)">引用</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="into-box">
                <el-input type="textarea" placeholder="输入您要搜索的内容" @keydown.enter.native="sendAiCreateCourse"
                    v-model="textarea">
                </el-input>
                <div class="btm-box">
                    <!-- <div class="opt">
                        <img style="width: 1.3rem;height: auto;" src="../../assets/image/magSys/yy.png" alt="">
                    </div> -->
                    <div class="opt-1">
                        <el-tooltip class="item" effect="dark" :content="isEnding ? '发送' : '暂停'" placement="top-start">
                            <div class="stop-box" @click="stopFetch" v-if="!isEnding"></div>
                            <img v-else style="width: 1.3rem;height: auto;" @click="sendAiCreateCourse"
                                src="../../assets/image/magSys/send.png" alt="">
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { fetchSSE, stopFetchSSE } from "@/api/sse";
import TurndownService from 'turndown';
import Hls from 'hls.js';
import { QueryResDataDetail } from '@/api/resourceMag';
import Utils from '@/assets/js/Utils';
export default {
    data() {
        return {
            visible: false,
            textarea: '',
            questionInfos: [],
            isEnding: true,
            isBig: false
        }
    },
    mounted() {
    },
    methods: {
        /**停止输出 */
        stopFetch() {
            stopFetchSSE();
            this.isEnding = true;
        },
        close() {
            this.visible = false;
            this.isBig = false;
        },
        /**放大 */
        openBig(value) {
            this.isBig = value;
        },
        /**滚动到底部 */
        scrollBottom() {
            this.$nextTick(() => {
                let dom = document.querySelector('.ipt-box');
                if (dom) {
                    dom.scrollTo({
                        top: dom.scrollHeight,
                        behavior: "smooth" // 可选平滑动画
                    });
                }
            })
        },
        async copy(item) {
            const turndownService = new TurndownService();
            const markdown = turndownService.turndown(item.originData);
            // 3. 复制到剪贴板
            try {
                await navigator.clipboard.writeText(markdown);
                this.$msg({
                    showClose: true,
                    message: '复制成功',
                    type: "success",
                });
            } catch (err) {
                navigator.clipboard.writeText(item.originData);
            }
        },
        /**播放视频 */
        playVideo(url) {
            const audio = document.getElementById("audio");
            const hls = new Hls();
            if (Hls.isSupported()) {
                hls.loadSource(url);
                hls.attachMedia(audio);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    audio.play();
                });
            } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
                audio.src = url;
                audio.addEventListener("canplay", function () {
                    audio.play();
                });
            } else {
                console.error("HLS is not supported in this browser");
            }
        },
        isHex32Id(str) {
            return /^[a-zA-Z0-9]+$/.test(str) && str.length == 32;
        },
        addPreview(obj, callback) {
            let arr = obj.questionAnswer.split('<strong>').slice(1);
            arr.forEach((item, index) => {
                if (item.indexOf('课程介绍视频') != -1) {
                    let arr1 = item.split('：');
                    arr1[1] = arr1[1].replaceAll('<br>', '');
                    let str = arr1[1].replaceAll('\n', '');
                    if (!this.isHex32Id(str)) return;
                    QueryResDataDetail({ id: str }).then(res => {
                        if (res.code == 200) {
                            let val = res.data.previewFileVOS.find(e => {
                                return e.orderIndex == -1;
                            })
                            if (!val) return;
                            obj.videoName = val.fileName;
                            obj.introduceVideoFileId = val.fileId; obj.m3u8 = this.$severUrl(val.filePreviewUrl);
                            arr1[1] = `<br><video controls id="audio" autoplay style="width: auto;max-height: 30rem;margin-top:1rem; muted"></video>`;
                            arr[index] = arr1.join('：') + '<br>';
                            let data = '<strong>' + arr.join('<strong>');
                            obj.questionAnswer = data;
                            this.$nextTick(() => {
                                this.playVideo(obj.m3u8);
                                let video=document.getElementById('audio');
                                video&&video.addEventListener('loadedmetadata',()=>{
                                    this.scrollBottom();
                                })
                            })
                            typeof callback == 'function' && callback(data);
                        }
                    })
                }
            })
        },
        /**基本信息引用数据处理 */
        baseHandle(item) {
            if (item.type != 'baseInfo') {
                this.$msg({
                    showClose: true,
                    message: "请引用正确的数据格式",
                    type: "warning",
                });
                return;
            };
            let arr = item.originData.split('<strong>').slice(1);
            let obj = {};
            let mapData = {
                '课程封面': 'coverImageUrl',
                '课程介绍视频': 'introduceVideoFileId',
                '课程名称': 'courseName',
                '参考标准': 'referenceStandard',
                '课程特色': 'courseFeature',
                '课程目标': 'courseTarget',
                '课程简介': 'courseDescription',
                '课程设计': 'courseDesign'
            };
            arr.forEach(el => {
                let index = el.indexOf('</strong>');
                if (index != -1) {
                    let key = mapData[el.slice(0, index)];
                    if (!key) return;
                    if (['introduceVideoFileId'].includes(key)) {
                        obj[key] = item.introduceVideoFileId;
                        return;
                    }
                    obj[key] = el.slice(index);
                    obj[key] = obj[key].replaceAll('</strong>', '');
                    obj[key] = obj[key].replaceAll('：', '');
                }
            });
            obj.videoName = item.videoName;
            Utils.$emit('ai_create_course', obj);
        },
        /**章节目录引用数据处理 */
        chapterHandle(item) {
            if (item.type != 'chapter') {
                this.$msg({
                    showClose: true,
                    message: "请引用正确的数据格式",
                    type: "warning",
                });
                return;
            };
            let str = item.questionAnswer;
            const lines = str.split('\n').filter(line => line.trim() !== '');
            const tree = [];
            let currentChapter = null;
            let currentSection = null;

            lines.forEach(line => {
                const trimmed = line.trim();

                // 处理章
                const chapterMatch = trimmed.match(/<strong>(.*?)<\/strong>/);
                if (chapterMatch) {
                    currentChapter = { name: chapterMatch[1], children: [] };
                    tree.push(currentChapter);
                    currentSection = null; // 重置当前节
                    return;
                }

                // 处理节（改进版正则）
                const sectionMatch = trimmed.match(/^(\d+)\s*(.+)$/);
                if (sectionMatch) {
                    if (!currentChapter) {
                        currentChapter = { name: '未命名章节', children: [] };
                        tree.push(currentChapter);
                    }
                    currentSection = { name: sectionMatch[2], children: [] };
                    currentChapter.children.push(currentSection);
                    return;
                }

                // 处理子项（宽松处理）
                const itemMatch = trimmed.match(/^-\s*(.+)$/);
                if (itemMatch) {
                    const item = { name: itemMatch[1] };
                    if (currentSection) {
                        currentSection.children.push(item);
                    } else if (currentChapter) {
                        // 作为章的直属子项
                        currentChapter.children.push(item);
                    }
                }
            });
            Utils.$emit('ai_create_course_selection', tree);
        },
        /**引用 */
        useString(item) {
            if (this.activeName == 'baseInfo') {
                this.baseHandle(item);
            } else {
                this.chapterHandle(item);
            }
        },
        extractImageUrls(str) {
            // 核心正则：匹配http/https协议 + 任意非空白字符 + 图片扩展名（支持带查询参数）
            const regex = /https?:\/\/[^\s?#]+?\.(jpg|jpeg|png|gif|bmp|webp)(?:\?[^\s#]*)?/gi;
            return str.match(regex) || []; // 返回匹配数组，无则返回空数组
        },
        extractVideoUrls(str) {
            // 匹配http/https协议 + 任意非空白字符 + 视频扩展名（支持带参数）
            const regex = /https?:\/\/[^\s?#]+?\.(mp4|mov|avi|wmv|flv|mkv|webm)(?:\?[^\s#]*)?/gi;
            return str.match(regex) || []; // 返回数组，无则返回空数组
        },
        /**发送ai组课请求 */
        sendAiCreateCourse() {
            if (!this.isEnding) {
                this.$msg({
                    showClose: true,
                    message: "请等待输出完毕后再操作",
                    type: "warning",
                });
                return;
            }
            this.isEnding = false;
            let questionObj = {
                userQuestion: this.textarea,
                questionAnswer: '',
                originData: '',
                isEnding: false,
                type: this.activeName,
                status: true,
            };
            this.questionInfos.push(questionObj);
            this.textarea = '';
            let accountType = this.$store.state.user.userInfo.accountType;
            let obj = {
                '-1': 'system',
                '0': 'company',
                '1': 'user'
            };
            let obj1 = {
                'baseInfo': 1,
                'chapter': 2
            }
            this.scrollBottom();
            let params = {
                "userName": this.$store.state.user.userInfo.userName.trim(),
                "userType": obj[accountType] || '',
                "prompt": questionObj.userQuestion,
                "type": obj1[this.activeName] || ''
            };
            let imgFlag = false;
            let videoFlag = false;
            fetchSSE('/api/ai/course/generate', params, (chunk) => {
                if (!imgFlag) {
                    let httpArr = this.extractImageUrls(questionObj.questionAnswer);
                    if (httpArr.length > 0) {
                        let str = `<br><img  style="max-width:100%;height:auto;margin-top:1rem" src="${httpArr[0]}" alt="">`
                        questionObj.questionAnswer = questionObj.questionAnswer.replace(httpArr[0], str);
                        imgFlag = true;
                    }
                }
                if (!videoFlag) {
                    let httpArr = this.extractVideoUrls(questionObj.questionAnswer);
                    if (httpArr.length > 0) {
                        let str = `<br><video controls autoplay style="width: 100%;height: auto;margin-top:1rem; muted" src="${httpArr[0]}"></video>`
                        questionObj.questionAnswer = questionObj.questionAnswer.replace(httpArr[0], str);
                        videoFlag = true;
                    }
                }
                try {
                    if (chunk.includes('CLOSE_CONNECTION')) {
                        questionObj.isEnding = true;
                        this.isEnding = true;
                        this.scrollBottom();
                        this.addPreview(questionObj);
                        return;
                    }
                    chunk = chunk.split("data:");
                    if (chunk && typeof chunk != 'string' && chunk.length > 0) {
                        chunk.map(item => {
                            let jsonString = ""
                            if (item.includes("{") && !item.includes("SEARCHING") && !item.includes("KNOWLEDGEBASE")) {
                                item = item.trim()
                                item = JSON.parse(item)
                                item["key"] = item["key"].replaceAll('$$', '<strong>');
                                item["key"] = item["key"].replaceAll('%%', '</strong>');
                                item["key"] = item["key"].replaceAll('CLOSE_CONNECTION', '');
                                item["key"] = item["key"].replace(/\\n/g, '\n');
                                jsonString = item["key"];
                            }
                            questionObj.questionAnswer = questionObj.questionAnswer + jsonString;
                            questionObj.originData = questionObj.originData + jsonString;
                        })
                    }
                    this.scrollBottom();
                } catch (err) {
                    console.log(err, 'oooo')
                }
            }).catch(err => {
                this.isEnding = true;
                questionObj.isEnding = true;
                questionObj.status = false;
                questionObj.questionAnswer = '服务器异常';
            })
        }
    },
    computed: {
        activeName() {
            return this.$store.state.course.activeName;
        },
    }
}
</script>

<style lang="less" scoped>
.group-box {
    width: 100rem;
    height: 65rem;
    background: linear-gradient(67deg, rgba(221, 242, 254, 0.90) 0%, rgba(221, 242, 254, 0.90) 5%, rgba(217, 210, 241, 0.90) 50%, rgba(11, 74, 202, 0.90) 100%);
    // border: 2px solid;
    border-image: linear-gradient(0deg, rgba(198, 171, 255, 0.15), #385fae) 2 2;
    border-radius: 16px;
    position: absolute;
    top: 25rem;
    right: 3rem;
    transition: all 0.3s;
    padding: 3rem;
    z-index: 999;
    overflow: hidden;
}

.talk-box {
    margin-top: 3rem;
    display: flex;
    align-items: flex-start;
    height: calc(100% - 23rem);

    .ipt-box {
        height: 100%;
        width: calc(100% - 5rem);
        background: rgba(255, 255, 255, 0.90);
        border: 2px solid;
        border-image: linear-gradient(0deg, rgba(198, 171, 255, 0.15), #385fae) 2 2;
        border-radius: 16px;
        margin-left: 1rem;
        padding: 3rem;
        display: flex;
        flex-direction: column;
        overflow: auto;

        .content-box {
            flex: 1;
            color: #334681;
            white-space: wrap;
        }

        .question-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        .opt-box {
            display: flex;
            color: #889ED2;
            margin-top: 3rem;

            &> :nth-child(n) {
                cursor: pointer;
            }

            &> :nth-child(2) {
                margin-left: 3rem;
            }
        }
    }
}

.active {
    height: 0 !important;
    opacity: 0;
}

.close {
    position: absolute;
    right: 0;
    top: 0;
    width: 3.6rem;
    height: auto;
}

.top {
    display: flex;
    align-items: center;

    i {
        margin-left: 1rem;
        font-size: 2rem;
        color: #385FAE;
        cursor: pointer;
    }

    &> :nth-child(2) {
        font-weight: 700;
        font-size: 16px;
        color: #385FAE;
        margin-left: 4rem;
    }
}

.into-box {
    height: 12rem;
    background-color: #ffffff;
    border: 2px solid;
    border-image: linear-gradient(0deg, rgba(198, 171, 255, 0.15), #385fae) 2 2;
    border-radius: 16px;
    margin-left: 5rem;
    margin-top: 3rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &> :nth-child(1) {
        flex: 1;
    }

    .btm-box {
        display: flex;
    }
}

.opt {
    width: 3.2rem;
    height: 3.2rem;
    background: #e8ebf4;
    border-radius: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.opt-1 {
    width: 3.2rem;
    height: 3.2rem;
    background: #436CF1;
    border-radius: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 12px;
}

/deep/.el-textarea__inner {
    height: 100%;
    border: 0.1rem solid transparent;
}

@keyframes slide-in {
    0% {
        height: 0;
    }

    100% {
        transform: 65rem;
    }
}

@keyframes slide-out {
    0% {
        transform: 65rem;
    }

    100% {
        transform: 0;
    }
}

.slide-enter-active {
    animation: slide-in 0.3s;
}

.slide-leave-active {
    animation: slide-in 0.3s reverse;
}

.user-question {
    background-color: #95ec69;
    padding: 1.5rem 2rem;
    border-radius: 1rem;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    word-break: break-all;
    margin-top: 2rem;
    line-height: 2rem;
}

.question-answer {
    background-color: #ffffff;
    padding: 1.5rem 2rem;
    border-radius: 1rem;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    margin-top: 2rem;
    word-break: break-all;
    white-space: var(--lineWrap);
    line-height: 2rem;
}

.stop-box {
    width: 12px;
    height: 12px;
    border: 0.2rem;
    background-color: #ffffff;
}

.dot-box {
    display: flex;
    background-color: #ffffff;
    padding: 1.5rem 2rem;
    border-radius: 1rem;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    margin-top: 2rem;

    &> :nth-child(n) {
        margin-left: 0.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.dot {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    background-color: #ccc;
    /* DeepSeek主题色可能是蓝色或灰色 */
    opacity: 0.3;
    animation: pulse 1.5s infinite ease-in-out;
}

.dot:nth-child(1) {
    animation-delay: 0s;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(0.9);
    }

    50% {
        opacity: 1;
        transform: scale(1.1);
    }
}

.big-screen {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
}
</style>